import { render, staticRenderFns } from "./StaticContent.vue?vue&type=template&id=5c97491d&"
import script from "./StaticContent.vue?vue&type=script&lang=js&"
export * from "./StaticContent.vue?vue&type=script&lang=js&"
import style0 from "./StaticContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports